import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import Motion from '@/app/components/Motion';

export const NewYearHeroBackground = () => {
  return (
    <Motion
      className="relative z-10 h-full"
      animate={{ opacity: 1, scale: 1 }}
      initial={{ opacity: 0, scale: 1.1 }}
      transition={{ duration: 1.5, type: 'tween' }}
      data-cy="new-year-hero-background"
    >
      <ArtDirectionImage
        className="object-cover"
        fill
        localizedAlt="new_year_hero_img_alt"
        priority
        sizes="100vw"
        srcSet={[
          {
            media: '(max-width: 767px)',
            src: 'new-year-hero/bdws-mobile.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.48&fp-y=0.65&fp-z=1.2',
          },
          {
            media: '(min-width: 767px)',
            src: 'new-year-hero-original/bdws-original.png?ar=3:2&fit=crop&crop=focalpoint&fp-x=0.37&fp-y=0.49&fp-z=1.7',
          },
        ]}
      />
    </Motion>
  );
};
